import { render, staticRenderFns } from "./Fankui.vue?vue&type=template&id=1b33f908&"
import script from "./Fankui.vue?vue&type=script&lang=js&"
export * from "./Fankui.vue?vue&type=script&lang=js&"
import style0 from "./Fankui.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports